import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import FauzyLogic from "@/components/FauzyLogic";
import { useSession } from "@/hooks/useSession";

const Landing = () => {
  const [focusText, setFocusText] = useState("");
  const { user } = useSession();
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (focusText.trim()) {
      navigate("/workspace", { state: { initialFocus: focusText, autoIterate: true } });
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-2xl space-y-8">
        {/* Logo */}
        <div className="flex flex-col items-center space-y-4">
          <div className="landing-logo-brand-wrap">
            <div className="landing-logo-brand-inner">
              <img
                src="/logo/light/android-chrome-512.png"
                alt="FauzyLogic Light Logo"
                className="landing-logo-img"
              />
              <h1 className="text-4xl font-bold tracking-tight landing-brand-text">
                <FauzyLogic />
              </h1>
            </div>
          </div>
        </div>

        {/* Main prompt */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Textarea
              id="focus-input"
              value={focusText}
              onChange={(e) => setFocusText(e.target.value)}
              placeholder="What would you like to focus on right now?"
              className="min-h-[120px] text-lg resize-none"
              autoFocus
            />
          </div>
          <Button 
            type="submit" 
            size="lg" 
            className="w-full"
            disabled={!focusText.trim()}
          >
            Begin
          </Button>
        </form>

        {/* Footer links */}
        <div className="flex justify-center space-x-6 text-sm text-muted-foreground">
          <a href="https://FauzyLogic.com" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
            About
          </a>
          {user ? (
            <>
              <span className="font-semibold text-foreground">{user.user_metadata?.full_name || user.email}</span>
              <button
                className="hover:text-foreground transition-colors underline ml-2"
                onClick={async () => { await supabase.auth.signOut(); }}
                type="button"
              >
                Log Out
              </button>
            </>
          ) : (
            <a href="/auth" className="hover:text-foreground transition-colors">
              Sign In
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default Landing;
